import { takeLatest, put, select } from 'redux-saga/effects';
import { forceReload as forceReloadUserList } from '~/components/containers/UserManagementContainer/reducer';
import type { AppState } from '~/reducers';
import callRequestSaga from '~/sagas/utils/request-saga';
import DeleteUserConstants from '~/components/containers/DeleteUserContainer/constants';
import UserManagementSubmenuConstants from '~/components/containers/UserManagementSubmenuContainer/constants';
import UserManagementAPI from '~/api/user-management-api';
import { redirectUser } from '~/ducks/router/actions';
import paths from '~/app/paths/paths';
import BaseException from '~/utils/fetch-wrapper/errors/BaseException';

export function* deleteUser({ userId }) {
  const response = yield* callRequestSaga(
    UserManagementAPI.deleteUser,
    {
      request: DeleteUserConstants.DELETE_USER_REQUEST,
      success: DeleteUserConstants.DELETE_USER_REQUEST_SUCCESS,
      failure: DeleteUserConstants.DELETE_USER_REQUEST_ERROR,
    },
    userId
  );

  if (response instanceof BaseException) {
    return;
  }

  //Close delete user modal
  yield put({ type: DeleteUserConstants.CLOSE_DELETE_USER_MODAL });

  //Reload submenu
  yield put({
    type: UserManagementSubmenuConstants.GET_USER_MANAGEMENT_SUBMENU,
  });

  //If there only was one user in this list before deleting this user, redirect user to list of all users
  const users = yield select(
    ({ userManagement }: AppState) => userManagement.userList.users
  );
  if (users.size === 1) {
    yield put(
      redirectUser({
        path: paths.getPeopleOrUsers().getPath({ user_role: 'all' }),
      })
    );
    return;
  }

  //Force update on next page load of user/invite list
  yield put(forceReloadUserList());
}

export function* deleteUserSaga() {
  // @ts-ignore
  yield takeLatest(DeleteUserConstants.DELETE_USER, deleteUser);
}

export default [deleteUserSaga];
